import { DateTimeFormatOptions, DateTime } from 'luxon';
import * as React from 'react';

export interface DateProps extends React.HTMLAttributes<HTMLSpanElement> {
  format?: keyof typeof DateTime | DateTimeFormatOptions;
  date: string | Date;
  language?: string;
}

export const formatDate = (
  date: string | Date,
  language: string = 'pl',
  format: keyof typeof DateTime | DateTimeFormatOptions = DateTime.DATE_SHORT,
): string => {
  return (
    DateTime.fromISO(typeof date === 'string' ? date : date.toISOString())
      // We need to set the locale to en-GB for English dates, else it will use en-US
      .setLocale(language === 'en' ? 'en-GB' : language)
      .toLocaleString(
        typeof format === 'string' ? (DateTime[format] as DateTimeFormatOptions) : format,
      )
  );
};

const DateFormatted: React.FC<DateProps> = ({ date, language, format, ...rest }) => {
  const selectedLanguage = language || localStorage.getItem('language') || 'pl';
  return <span {...rest}>{formatDate(date, selectedLanguage, format)}</span>;
};

export { DateFormatted };
